import {SearchTermsEnum} from './searchTermsEnum';

const termsBySearch = {
	[SearchTermsEnum.RAIO_X]: ['raio', 'raio x'],
	[SearchTermsEnum.TOMOGRAFIA]: ['tomo', 'tomografia'],
	[SearchTermsEnum.RESSONANCIA]: ['ressonancia', 'resso'],
	[SearchTermsEnum.ULTRASSONOGRAFIA]: ['ultrassom', 'ultrassonografia', 'ultra'],
	[SearchTermsEnum.DOR_DE_CABECA]: ['dor de cabeca', 'neuro', 'neurologia', 'neurologista'],
};

export {termsBySearch};
